// Nordeus Brand Guidelines

export const COLORS = {
  PRIMARY: {
    RED: '#E7482A',
    WHITE: '#FFFFFF'
  },
  SECONDARY: {
    BLUE: '#14409A',
    DARK_BLUE: '#1f1f4f',
    BLACK: '#000000',
    GREEN: '#31b457'
  }
}

export const FONTS = {
  PRIMARY: 'Heading Now, -apple-system, BlinkMacSystemFont, sans-serif',
  OFFICE: 'Corbel, -apple-system, BlinkMacSystemFont, sans-serif',
  GOOGLE: 'Poppins, -apple-system, BlinkMacSystemFont, sans-serif'
}

export const GRADIENTS = {
  PRIMARY: `linear-gradient(135deg, ${COLORS.SECONDARY.DARK_BLUE} 0%, #0f0f23 100%)`,
  ACCENT: `linear-gradient(135deg, ${COLORS.PRIMARY.RED} 0%, #ff6b47 100%)`,
  CARD: `linear-gradient(145deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)`,
  MODERN: `linear-gradient(100deg, #667eea 0%, ${COLORS.SECONDARY.BLUE} 40%, ${COLORS.SECONDARY.DARK_BLUE} 80%, ${COLORS.SECONDARY.BLACK} 100%)`
}
